import config from './config';

const currencies = {
    default: {
        sign: '£',
        code: 'GBP',
        position: config.currencyPosition.before,
    },
    'en-ie': {
        sign: '€',
        code: 'EUR',
        position: config.currencyPosition.after,
    },
    'en-gb': {
        sign: '£',
        code: 'GBP',
        position: config.currencyPosition.before,
    },
};

export default currencies;
